<template>
  <div>
    <el-button type="primary" icon="el-icon-plus" @click="dialogVisible = true">添加</el-button>
    <el-dialog
      :visible.sync="dialogVisible"
      title="添加活期宝"
      width="1200px"
      @close="closeDialog"
    >
      <div class="add-wrap">
        <el-button type="primary" @click="addItem()">
          <i class="el-icon-plus"></i>
          <span>新增</span>
        </el-button>
      </div>
      <div class="forms-wrap">
        <el-form v-for="(eachCurrent, index) in current" :model="eachCurrent" :key="index" :ref="'currentForm' + index" :rules="rules" label-width="100px" class="each-form">
          <el-form-item label="币种：" prop="coinType">
            <el-select v-model="eachCurrent.coinType" filterable placeholder="请选择(可搜索)">
              <el-option
                v-for="item in coinList"
                :key="item"
                :label="item"
                :value="item">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="日期：" prop="rateDate">
            <el-date-picker type="date" placeholder="选择日期" v-model="eachCurrent.rateDate"></el-date-picker>
          </el-form-item>
          <el-form-item label="年利率：" prop="yearRate">
            <el-input-number v-model="eachCurrent.yearRate" :min="0"></el-input-number>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleSave('currentForm')">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';

export default {
  name: 'CreateCurrent',
  data() {
    return {
      dialogVisible: false,
      current: [{}],
      rules: {
        coinType: [{ required: true, message: '币种不能为空！' }],
        rateDate: [{ required: true, message: '日期不能为空！' }],
        yearRate: [{ required: true, message: '年利率不能为空！' }]
      }
    };
  },
  computed: {
    ...mapState('currentSetting', ['coinList', 'contentTypeList'])
  },
  methods: {
    ...mapActions('currentSetting', ['create', 'list']),
    addItem() {
      this.current.push({});
    },
    closeDialog() {
      this.$refs['currentForm0'][0].resetFields();
      this.current = [{}];
    },
    handleSave(formName) {
      let _this = this;
      let isValid = true;
      this.current.forEach((v, i, a) => {
        _this.$refs['currentForm' + i][0].validate(valid => {
          if(!valid) {
            isValid = false;
          }
        });
      });
      if(!isValid) return;
      let reqData = this.current.slice();
      reqData.forEach((v, i, a) => {
        v.rateDate = v.rateDate.getTime();
      });
      this.create(reqData).then(() => {
        this.$message.success('添加成功！');
        this.dialogVisible = false;
        this.list();
      });
    }
  }
};
</script>

<style lang="less" scoped>
.forms-wrap {
  overflow: hidden;
}
.each-form {
  float: left;
  margin-bottom: 20px;
  border-bottom: 1px solid #e5e5e5;
}
.add-wrap {
  margin: 10px 30px;
}
.editor {
  height: 500px;
}
.val-input {
  width: 200px;
}
</style>
